import * as d3 from 'd3'

export function station(lineWidth: any) {
  return d3
    .arc()
    .innerRadius(0)
    .outerRadius(1 * lineWidth)
    .startAngle(0)
    .endAngle(2 * Math.PI)
}

export function transfer(lineWidth: any) {
  return d3
    .arc()
    .innerRadius(0)
    .outerRadius(1 * lineWidth)
    .startAngle(0)
    .endAngle(2 * Math.PI)
}
